<template>
  <div id="createIndividualWrap">
    <el-card
      shadow="hover"
      :style="{width: dialogWidth}"
    >
      <div slot="header">
        Create Individual
      </div>
      <div v-loading="state === 'loading'">
        <el-form
          v-if="formVisible"
          ref="createIndividualForm"
          label-width="80px"
          :model="createIndividualForm"
        >
          <el-form-item
            prop="email"
            label="Email"
            :error="error.email[0]"
          >
            <el-input v-model="createIndividualForm.email" />
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="submit"
            >
              Create User
            </el-button>
          </el-form-item>
        </el-form>

        <div
          v-if="!formVisible"
          class="validationMessage"
        >
          <i class="el-icon-success"></i><br /><br />
          Please validate your email address.
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    dialogWidth: {
      type: String,
      default: '50%',
    },
  },

  data() {
    return {
      createIndividualForm: {
        email: '',
      },
      rules: {
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] },
        ],
      },
      error: {
        email: [],
      },
      state: 'creating',
    };
  },

  computed: {
    formVisible() {
      return !this.state || this.state === 'creating' || this.state === 'loading';
    },
  },

  methods: {
    async submit() {
      this.state = 'loading';

      try {
        await api.accountCreate({
          email: this.createIndividualForm.email,
          role_type: 'individual',
        });
        this.state = 'valid';
      } catch (err) {
        const { data } = err.response;
        Object.keys(data).forEach((key) => {
          if (key in this.error) {
            this.error[key] = data[key];
          }
        });
        this.state = 'creating';
      }
    },
  },
};
</script>

<style lang="scss">
  #createIndividualWrap {
    width: 100%;

    .el-card {
      margin: 0 auto;
    }
  }
</style>
